import { render, staticRenderFns } from "./set-buy-send.vue?vue&type=template&id=f8caaaee&scoped=true&"
import script from "./set-buy-send.vue?vue&type=script&lang=js&"
export * from "./set-buy-send.vue?vue&type=script&lang=js&"
import style0 from "./set-buy-send.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./set-buy-send.vue?vue&type=style&index=1&id=f8caaaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8caaaee",
  null
  
)

export default component.exports